module.exports = __webpack_public_path__ + "static/media/2.95858fc5.jpg";